// extracted by mini-css-extract-plugin
export default {"submit":"EditCard_submit__a+Fc7","submitButton":"EditCard_submitButton__hxFy7","deleteButton":"EditCard_deleteButton__0UIXr"};